export default "__VITE_ASSET__Dhm91AfV__"